import _objectSpread from "/Users/fangyu/Code/unifygama/metacrm/metadesk-frontend/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import { defaultConverter as t, notEqual as e } from "../reactive-element.js";
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
const o = {
    attribute: !0,
    type: String,
    converter: t,
    reflect: !1,
    hasChanged: e
  },
  r = function () {
    let t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : o;
    let e = arguments.length > 1 ? arguments[1] : undefined;
    let r = arguments.length > 2 ? arguments[2] : undefined;
    const {
      kind: n,
      metadata: i
    } = r;
    let s = globalThis.litPropertyMetadata.get(i);
    if (void 0 === s && globalThis.litPropertyMetadata.set(i, s = new Map()), s.set(r.name, t), "accessor" === n) {
      const {
        name: o
      } = r;
      return {
        set(r) {
          const n = e.get.call(this);
          e.set.call(this, r), this.requestUpdate(o, n, t);
        },
        init(e) {
          return void 0 !== e && this.P(o, void 0, t), e;
        }
      };
    }
    if ("setter" === n) {
      const {
        name: o
      } = r;
      return function (r) {
        const n = this[o];
        e.call(this, r), this.requestUpdate(o, n, t);
      };
    }
    throw Error("Unsupported decorator location: " + n);
  };
function n(t) {
  return (e, o) => "object" == typeof o ? r(t, e, o) : ((t, e, o) => {
    const r = e.hasOwnProperty(o);
    return e.constructor.createProperty(o, r ? _objectSpread(_objectSpread({}, t), {}, {
      wrapped: !0
    }) : t), r ? Object.getOwnPropertyDescriptor(e, o) : void 0;
  })(t, e, o);
}
export { n as property, r as standardProperty };
//# sourceMappingURL=property.js.map